import { getCurrencySymbol } from '@utils/utils';

import { DiscountedPriceProps } from './type';
import { getNumberParts } from './utils';
import { DiscountedPriceContainer, TotalContainer } from './style';

const DiscountedPrice = ({
  price,
  currency = 'TL',
  size = 12,
  noLine,
  className,
  isTour = false,
  total,
}: DiscountedPriceProps) => {
  if (price === undefined) return null;

  const [whole, decimals] = getNumberParts(price);

  return (
    <div className={className || ''}>
      {isTour ? (
        <DiscountedPriceContainer size={size}>
          {`${whole},${decimals} ${getCurrencySymbol(currency)}`}
        </DiscountedPriceContainer>
      ) : noLine ? (
        <>
          {total ? (
            <TotalContainer>{`${whole},${decimals} ${getCurrencySymbol(
              currency
            )}`}</TotalContainer>
          ) : (
            <div>{`${whole},${decimals} ${getCurrencySymbol(currency)}`}</div>
          )}
        </>
      ) : (
        <DiscountedPriceContainer size={size}>
          {`${whole},${decimals} ${getCurrencySymbol(currency)}`}
        </DiscountedPriceContainer>
      )}
    </div>
  );
};

export default DiscountedPrice;
